// ===========================================
// HOOKS: Responsables por cliente — ORR-230 fase 4
// ===========================================

import { useQuery } from '@tanstack/react-query'
import { responsablesService, type MapaResponsables } from '../services/responsablesService'
import { useSupabase } from '@/lib/supabase-context'
import { useOrganizacion } from '@/core/providers/OrganizacionProvider'

/** Identidad estable para el estado "todavía no cargó": un `new Map()` inline rompe los memos. */
export const MAPA_VACIO: MapaResponsables = new Map()

export const responsablesKeys = {
  all: ['responsables-por-cliente'] as const,
  mapa: (orgId: string | null) => [...responsablesKeys.all, 'mapa', orgId] as const,
}

/**
 * Mapa `cliente_id → usuario_id[]` de toda la organización.
 *
 * Cambia solo cuando alguien edita los responsables de un cliente, así que se cachea largo:
 * `clientesService.sincronizarResponsables` invalida la clave.
 */
export function useMapaResponsables() {
  const { supabase } = useSupabase()
  const { organizacionId } = useOrganizacion()

  return useQuery({
    queryKey: responsablesKeys.mapa(organizacionId),
    queryFn: () => responsablesService.listarMapa(supabase!, organizacionId!),
    enabled: Boolean(supabase && organizacionId),
  })
}
